import {observable} from 'mobx';
import lqApi from '../api';

export default class ReservationStore {
    @observable reservationDateList = null;
    @observable optionGroups = [];
    @observable optionDataList = [];
    @observable reservationInfo = {};

    setReservationOptionGroup = async (pin, roSeq, date) => {
        if(!pin) {
            alert('유효하지 않은 핀번호로 인해 예약날짜를 불러올 수 없습니다.');
            return false;
        }

        const data = await lqApi.getOptionGroupData(pin, roSeq, date);
        const hasOptionGroups = Array.isArray(data) && data.length > 0;
        if (!hasOptionGroups) return false;

        this.optionGroups = data;
        return data;
    };

    get getOptionGruops() {
        return this.optionGroups;
    }

    setReservationDataList = async (pin) => {
        if(!pin) {
            alert('유효하지 않은 핀번호로 인해 예약날짜를 불러올 수 없습니다.');
            return false;
        }

        const data = await lqApi.getReservationDate(pin);
        const reserveDates = data.stringReserveDate;
        const hasReservationDataList = Array.isArray(reserveDates) && reserveDates.length > 0;
        if (!hasReservationDataList) {
            alert('예약날짜를 불러올 수 없습니다.');
            return false;
        }

        this.reservationInfo = data;
        this.reservationDateList = reserveDates;
        return true;
    };

    get getReservationInfo() {
        return this.reservationInfo;
    }
    get getReservationDate() {
        return this.reservationDateList;
    }

    callReservation({ selectedDate, selectedOptions, pin, orderDetailSeq }) {
        const isValidDate = !!selectedDate;
        if(!isValidDate) {
            alert('날짜 정보가 유효하지 않습니다.');
            return false;
        }

        const data = { reservationDate: selectedDate, pin, orderDetailSeq };
        if(selectedOptions.length > 0) {
            data.reservationOptions = selectedOptions.map(option => Number(option));
        }

        return lqApi.callReservation(data.pin, data);
    }

    setReservationResult = pin => {
        if(!pin) {
            alert('핀번호가 유효하지 않습니다.');
            return false;
        }

        return lqApi.getReservationInfo(pin);
    };
}


// WEBPACK FOOTER //
// ./src/stores/ReservationStore.js